import { render, staticRenderFns } from "./TravelAssistance.vue?vue&type=template&id=7534c99c"
import script from "./TravelAssistance.vue?vue&type=script&lang=js"
export * from "./TravelAssistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports